import React from 'react';
import { Button, Row, Col, Spinner } from 'reactstrap';
import { util } from '../Util';
import { SmallButton } from '../common/forms/FormElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import CommonContext, { ApiRoutes } from '../Common';

export class EmployeeCertificationInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            certifications: [],
        };
    }

    static contextType = CommonContext;

    componentDidMount() {
        this.populateState();
    }

    getCertificationName = (employeeCertification) => {
        if (!employeeCertification) {
            return '';
        }

        const { certifications } = this.state;
        const foundCert = certifications.find(
            (c) => c.id === employeeCertification.certificationId
        );

        return foundCert ? foundCert.name : '';
    };

    getCertificationAbbr = (employeeCertification) => {
        if (!employeeCertification) {
            return '';
        }

        const { certifications } = this.state;
        const foundCert = certifications.find(
            (c) => c.id === employeeCertification.certificationId
        );

        return foundCert ? foundCert.abbreviation : '';
    };

    downloadAttachment = (empCert) => {
        const url = ApiRoutes.employeeCertification.download(empCert.id);
        window.open(url, '_blank');
    };

    async populateState() {
        const [certifications] = await Promise.all([
            util.fetch.js(ApiRoutes.certification.all()),
        ]);

        this.setState({ certifications, loading: false });
    }

    render() {
        const { employeeCertifications } = this.props;

        if (this.state.loading) {
            return <Spinner />;
        }

        return (
            <>
                <Row className="pb-1">
                    <Col>
                        <div className="d-flex flex-row align-items-center justify-content-end">
                            <CommonContext.Consumer>
                                {(value) => (
                                    <SmallButton
                                        disabled={!!value.formIsOpen}
                                        type="button"
                                        onClick={() => this.props.onAddEmployeeCertification(true)}
                                    >
                                        <i className="fa fa-plus-circle fa-md mr-2" />
                                        Add Certification
                                    </SmallButton>
                                )}
                            </CommonContext.Consumer>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-sm table-bordered">
                            <thead className="text-muted">
                                <tr>
                                    <th>Name</th>
                                    <th>Effective Date</th>
                                    <th>Expiration Date</th>
                                    <th>Status</th>
                                    <th>Proof</th>
                                    <th
                                        className="text-center"
                                        style={{ width: '30px' }}
                                    />
                                </tr>
                            </thead>
                            <tbody>
                                {!(employeeCertifications ?? []).length ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No certifications found.
                                        </td>
                                    </tr>
                                ) : (
                                    employeeCertifications.map((empCert) => {
                                        const certName = this.getCertificationName(empCert);
                                        const rowClass = empCert.isActive ? '' : 'text-muted bg-light';

                                        const expirationDateDisplay = empCert.expirationDate
                                            ? util.date.getShort(empCert.expirationDate)
                                            : 'N/A';
                                        const isExpired =
                                            empCert.expirationDate &&
                                            new Date(empCert.expirationDate) < new Date();
                                        const status = isExpired ? 'Expired' : 'Current';

                                        return (
                                            <tr
                                                key={empCert.id}
                                                className={rowClass}
                                            >
                                                <td>{certName}</td>
                                                <td>
                                                    {util.date.getShort(empCert.effectiveDate)}
                                                </td>
                                                <td>{expirationDateDisplay}</td>
                                                <td>{status}</td>
                                                <td>
                                                    {empCert.normalizedFileName ? (
                                                        <Button
                                                            color="link"
                                                            size="sm"
                                                            onClick={() => this.downloadAttachment(empCert)}
                                                        >
                                                            <FontAwesomeIcon icon={faDownload} />
                                                        </Button>
                                                    ) : (
                                                        'No File available'
                                                    )}
                                                </td>


                                                <td>
                                                    <Button
                                                        type="button"
                                                        color="outline-primary"
                                                        onClick={() =>
                                                            this.props.onEditEmployeeCertification(empCert)
                                                        }
                                                        size="sm"
                                                    >
                                                        Edit
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </>
        );
    }
}
